import * as links from 'documents-lib/js/lib/links';
import { canWrite } from 'documents-ui/lib/permissions';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DescriptionEmptyState = ({
  deckId
}) => {
  const renderDescription = () => {
    return canWrite() ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "summary.description.emptyState.descriptionWithLink",
      options: {
        documentDetailsLink: /*#__PURE__*/_jsx(Link, {
          href: links.getSummaryPageURL(deckId),
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.description.emptyState.link"
          })
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.description.emptyState.description"
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "1000",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(Illustration, {
      "data-test-id": "description-empty-state-illustration",
      name: "documents",
      width: "40%",
      maxBlockSize: "120px"
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.description.emptyState.title"
        })
      }), renderDescription()]
    })]
  });
};
export default DescriptionEmptyState;